module.exports = __webpack_public_path__ + "tuvalu.svg?8f6deca787fc2cbdd737ea3af3f26663";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/tuvalu.svg
// module id = 327
// module chunks = 10